import classNames from 'classnames';
import React from 'react';
import Ink from 'react-ink';
import Size from '../../types/enum/Size';
import Theme from '../../types/enum/Theme';
import './Button.scss';
import IButtonProps from './ButtonProps';

const Button = ({
  tag = 'div',
  type,
  size = Size.MEDIUM,
  value = '',
  theme,
  rounded = false,
  shadow = false,
  fullWidth = false,
  disabled = false,
  ripple = true,
  tabIndex = 0,
  onClick,
  onMouseDown,
  onMouseUp,
  onFocus,
  onBlur,
  onKeyDown,
  forwardRef,
  className,
  children,
  linkProps,
  ...other
}: IButtonProps) => {
  function handleClick(event: React.MouseEvent) {
    if (!disabled && onClick) {
      onClick(event);
    }
  }

  function handleOnMouseDown(event: React.MouseEvent) {
    if (!disabled && onMouseDown) {
      onMouseDown(event);
    }
  }

  function handleOnMouseUp(event: React.MouseEvent) {
    if (!disabled && onMouseUp) {
      onMouseUp(event);
    }
  }

  function handleFocus(event: React.FocusEvent) {
    if (!disabled && onFocus) {
      onFocus(event);
    }
  }

  function handleBlur(event: React.FocusEvent) {
    if (!disabled && onBlur) {
      onBlur(event);
    }
  }

  function handleKeyDown(event: React.KeyboardEvent) {
    if (!disabled) {
      onKeyDown?.(event);
    }
  }

  function renderChildren() {
    return (
      <>
        <span className="btn-label">{children}</span>
        {!disabled && ripple && <Ink background={false} />}
      </>
    );
  }

  const classes = classNames(
    {
      'btn': true,
      'btn-dark': theme === Theme.DARK,
      'btn-rounded': rounded,
      'btn-shadow': shadow,
      'btn-full-width': fullWidth,
      'disabled': disabled,
      [`btn-${size}`]: true,
      [`btn-${type}`]: type,
    },
    className
  );

  return React.createElement(tag, {
    className: classes,
    value,
    onClick: handleClick,
    onMouseDown: handleOnMouseDown,
    onMouseUp: handleOnMouseUp,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onBlur: handleBlur,
    tabIndex: !disabled ? tabIndex : -1,
    ref: forwardRef,
    children: renderChildren(),
    ...linkProps,
    ...other,
  });
};

export default Button;
